// i18n area 'system' — locale hr-HR (task #171, onda 4): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/system.hr-HR.meta.json.
import type { enUS } from './system'

export const hrHR: typeof enUS = {
  diagnostics: {
    title: 'Dijagnostika',
    subtitle: 'Što ne valja, najgore prvo — ista leća kao tvirt diagnose',
    reload: 'Ponovno učitaj',
    loadError: 'Dijagnozu nije bilo moguće pročitati',
    exportBundle: 'Izvezi paket',
    exportError: 'Paket nije bilo moguće izraditi',
    noProblem: 'Nema problema u pregledanim područjima',
    nothingInspected: 'NIŠTA nije pregledano — ovo nije potvrda dobrog zdravlja',
    inspected: 'Pregledana',
    notInspected: 'NIJE pregledano',
    localHint: 'Lokalna područja čvora (systemd jedinice, journal) čitaju se samo iz CLI-ja: tvirt diagnose --area local — put kad API ne odgovara.',
    thresholds: 'neuspjeli zadaci unutar {hours} h, heartbeat kasni više od {seconds} s',
    severity: {
      critical: 'Kritično',
      warning: 'Upozorenje',
      unknown: 'Nepoznato'
    }
  },
  explorer: {
    title: 'Preglednik resursa',
    root: 'Korijen',
    empty: 'U ovom scopeu nema nijednog resursa',
    previewHint: 'Odaberite objekt da vidite njegov pretpregled',
    open: 'Otvori',
    openScoped: 'Otvori popis u ovom scopeu',
    kinds: {
      vm: 'VM',
      vmTemplate: 'Predložak VM-a',
      ct: 'CT',
      ctTemplate: 'Predložak CT-a',
      app: 'Aplikacija',
      overlayNetwork: 'Overlay mreža',
      networkService: 'Mrežna usluga',
      fabric: 'Fabric',
      subnet: 'Podmreža',
      storage: 'Storage pool',
      disk: 'Disk',
      catalogFile: 'Datoteka kataloga',
      ociRegistry: 'OCI registar',
      ociImage: 'OCI slika',
      cephCluster: 'Ceph klaster',
      backupDestination: 'Odredište backupa',
      user: 'Korisnik',
      group: 'Grupa',
      role: 'Uloga',
      credential: 'Vjerodajnica',
      tag: 'Tag',
      proximityRule: 'Pravilo blizine'
    }
  },
  tags: {
    title: 'Tagovi',
    empty: 'Nema tagova',
    add: 'Dodaj tag',
    remove: 'Ukloni',
    name: 'Tag',
    value: 'Vrijednost',
    save: 'Spremi',
    saveError: 'Tagove nije moguće spremiti',
    loadError: 'Rječnik tagova nije moguće učitati',
    noVocabulary: 'Za ovu vrstu resursa nije dostupan nijedan tag',
    overwrite: 'Zamijeni trenutačnu vrijednost',
    createTitle: 'Stvori tag',
    editTitle: 'Uredi tag',
    nameHint: 'Slova, znamenke, točke, crtice i podvlake — bez ":" i bez "/"; prefiks tvirt- rezerviran je za platformu',
    cardinality: 'Kardinalnost',
    cardinalitySingle: 'Jedna vrijednost',
    cardinalityMultiple: 'Više vrijednosti',
    cardinalityHint: 'S jednom vrijednošću, ponovna dodjela taga traži njezinu zamjenu',
    autoCreate: 'Automatsko stvaranje vrijednosti',
    autoCreateOn: 'Pri dodjeli',
    autoCreateOff: 'Samo deklarirane',
    autoCreateHint: 'Uključeno: dodjela nove vrijednosti stvara je. Isključeno: dodjeljuju se samo deklarirane vrijednosti',
    values: 'Vrijednosti',
    noValues: 'Nijedna vrijednost nije deklarirana',
    addValue: 'Dodaj vrijednost',
    duplicateValue: 'Duplicirana vrijednost',
    kinds: 'Vrste resursa',
    kindsAll: 'Sve',
    kindsPlaceholder: 'Sve',
    kindsHint: 'Ostavite prazno da dopustite svaku vrstu resursa koja se može tagirati',
    systemChip: 'Sustav',
    deleteCascade: 'Ukloni i dodjele',
    deleteCascadeHint: 'Oznaka koja je još dodijeljena nekom resursu odbija se: s ovom opcijom vrijednosti i sve dodjele odlaze zajedno s oznakom.'
  },
  scopes: {
    title: 'Scopeovi',
    createTitle: 'Stvori scope',
    editTitle: 'Preimenuj scope',
    path: 'Putanja',
    segment: 'Segment',
    segmentHint: 'Mala slova, znamenke i crtice (DNS-1123)',
    parent: 'Roditelj',
    rootChip: 'Korijen',
    preview: 'Novi scope',
    pickLabel: 'Scope',
    pickHint: 'Gdje objekt živi u stablu klastera — korijen ili vDC unutar njega.',
    ociCache: 'OCI predmemorija (override)',
    appEphemeral: 'Efemerni pool za aplikacije (override)',
    inherit: 'Naslijedi',
    inheritsFrom: 'Nasljeđuje od',
    inheritsCluster: 'Nasljeđuje zadano klastera',
    inheritsNone: 'Nasljeđuje — nema efektivnog poola',
    failoverProtection: 'Zaštita u degradaciji',
    networkWeight: 'Mrežna težina',
    networkCeil: 'Mrežna gornja granica (Mbps)',
    protectionProtected: 'Zaštićen',
    protectionExpendable: 'Može se žrtvovati u degradaciji',
    protectionDefault: 'Zadano klastera'
  },

  sysinfo: {
    summary: 'Verzije platforme u klasteru, komponente svakog čvora, administracijski priručnik i licenca.',
    platformTitle: 'Platforma TVirt',
    platformSubtitle: 'Verzije uočene na čvorovima klastera',
    versionOnNodes: '{version} na čvorovima: {n}',
    versionOnOneNode: '{version} na 1 čvoru',
    mixedVersions: 'Više od jedne verzije platforme u klasteru — očekivano samo dok je nadogradnja u tijeku (najviše dvije).',
    tooManyVersions: 'Više od dvije verzije platforme u klasteru — to se ne očekuje nikad, čak ni usred nadogradnje: provjerite čvorove u nastavku.',
    unreportedNodes: 'Još nema izvještaja o verzijama od: {nodes}',
    noVersionsYet: 'Nijedan čvor još nije prijavio svoje verzije.',
    nodesUnavailable: 'Popis čvorova nije vidljiv s vašim dozvolama — verzije platforme nije moguće prikazati.',
    colNode: 'Čvor',
    manualTitle: 'Administracijski priručnik',
    manualSubtitle: 'Lokalna kopija, poslužuje je ovaj klaster',
    manualBody: 'Cjeloviti priručnik za TVirt u PDF-u, poslužen izravno s platforme — dostupan i u air-gapped okruženjima.',
    manualLink: 'Administracijski priručnik (PDF)',
    apiExplorerTitle: 'API preglednik',
    apiExplorerSubtitle: 'OpenAPI ugovor, dostupan za pregled',
    apiExplorerBody: 'Cjeloviti OpenAPI ugovor platforme — svaka ruta, shema i kod odgovora — dostupan za pregled iz preglednika, poslužen kroz ovaj čvor.',
    apiExplorerLink: 'Istraži API',
    kubeTitle: 'Kompatibilnost s Kubernetesom',
    kubeSubtitle: 'kubectl i njegovi alati, ispred nativnog API-ja',
    kubeBody: 'TVirt KubeCompat projicira Podove, Deploymente, Servicee, namespaceove, čvorove i događaje u Kubernetes dijalekt — samo za čitanje, plus brisanje Deploymenata. Svaki poziv prolazi kroz nativni API s tvojim dozvolama: u kubeconfigu koristi app token kao bearer.',
    kubeEndpoint: 'Endpoint za kubectl',
    kubeStatusActive: 'Aktivan — Kubernetes {version}',
    kubeStatusMissing: 'Nije instaliran na ovom čvoru (paket trantor-tvirt-kubecompat)',
    kubeStatusDown: 'Instaliran, ali ne odgovara — provjeri jedinicu trantor-tvirt-kubecompat',
    kubeStatusChecking: 'Provjera…'
  },

  licensing: {
    title: 'Licenca klastera',
    subtitle: 'Pretplatnička licenca — najviše jedna po klasteru',
    absentTitle: 'Nema registrirane licence',
    absentBody:
      'Bez valjane licence klaster odbija pokretati nove virtualne strojeve (uključeni VM-ovi ostaju uključeni). Registrirajte ključ proizvoda koji ste dobili s pretplatom.',
    registerButton: 'Registriraj licencu',
    removeButton: 'Ukloni licencu',
    state: {
      ok: 'Valjana',
      limitExceeded: 'Prekoračeno ograničenje',
      expired: 'Istekla'
    },
    productKeyLabel: 'Ključ proizvoda',
    basisLabel: 'Osnova ograničenja',
    basis: {
      concurrentVms: 'Istodobno uključeni VM-ovi',
      physicalCores: 'Fizičke jezgre (ukupno u klasteru)'
    },
    limitLabel: 'Ograničenje',
    usageLabel: 'Trenutačna upotreba',
    usageOf: '{used} od {limit}',
    usagePartial: 'djelomični zbroj — čvorova bez uočene CPU topologije: {n}',
    usageUnknown: 'trenutačno se ne može utvrditi',
    expiresLabel: 'Istek',
    neverExpires: 'nikad',
    registeredLabel: 'Registrirana',
    gateNote:
      'S licencom koja je odsutna, istekla ili preko ograničenja klaster odbija pokretati NOVE virtualne strojeve. Uključeni VM-ovi ostaju uključeni, a HA ponovna pokretanja time nisu pogođena.',
    devStage:
      'Razvojna faza: ključ proizvoda prihvaća se kakav jest, zajedno s ovdje deklariranim ograničenjima; validacija potpisanim ključem stiže u budućem izdanju.',
    dialogTitle: 'Registrirajte licencu',
    dialogExpiresHelp: 'Prazno = licenca nikad ne istječe',
    dialogSubmit: 'Registriraj',
    dialogError: 'Licencu nije moguće registrirati.',
    removeTitle: 'Uklonite licencu',
    removeBody:
      'Klaster će raditi BEZ LICENCE: novi virtualni strojevi odbijat će se pokrenuti dok ne registrirate licencu. Uključeni VM-ovi ostaju uključeni.',
    removeConfirm: 'Ukloni',
    removeError: 'Licencu nije moguće ukloniti.'
  },
  rbac: {
    tabRoles: 'Uloge',
    tabGrants: 'Ovlaštenja',
    rolesTitle: 'Uloge',
    createRoleTitle: 'Stvori ulogu',
    editRoleTitle: 'Uredi ulogu',
    nameHint: 'Mala slova, znamenke i crtice; prefiks tvirt- je rezerviran',
    systemChip: 'Sustav',
    permissions: 'Dozvole',
    permissionsPlaceholder: 'Dodaj dozvolu…',
    includedRoles: 'Uključene uloge',
    includedRolesPlaceholder: 'Dodaj ulogu…',
    grantsTitle: 'Ovlaštenja',
    createGrantTitle: 'Stvori ovlaštenje',
    principal: 'Principal',
    principalKind: 'Vrsta principala',
    principalUser: 'Korisnik',
    principalGroup: 'Grupa',
    role: 'Uloga',
    grantRight: 'Delegiranje',
    grantRightChip: 'Može delegirati',
    grantRightLabel: 'S pravom delegiranja (primatelj može ovu ulogu dalje delegirati)',
    effective: 'Efektivno',
    notEffective: 'Nije efektivno',
    createdAt: 'Stvoreno',
    scopeHint: '/path točno, /path/* rekurzivno — ovlaštenja se sidre na montirani korijen (/* se ne može delegirati)'
  },
  groups: {
    title: 'Grupe',
    createTitle: 'Stvori grupu',
    nameHint: 'Mala slova, znamenke i crtice; jedinstveno unutar scopea',
    members: 'Članovi',
    membersTitle: 'Članovi',
    membersPlaceholder: 'Dodaj korisnika…',
    noMembers: 'Nema članova',
    realmMappings: 'Mapiranja realmova',
    realmMappingsTitle: 'Mapiranja realmova',
    realmMappingsHint:
      'Čemu ova grupa odgovara u svakom vanjskom realmu. Članstvo se čita iz direktorija pri prijavi: grupa direktorija koju nitko ovdje ne mapira zanemaruje se, a ugniježđivanje se ne razrješava — izravnajte ga na strani direktorija.',
    realm: 'Realm',
    externalGroup: 'Vanjska grupa',
    addRealmMapping: 'Dodaj mapiranje',
    removeRealmMapping: 'Ukloni mapiranje',
    noRealmMappings: 'Nema mapiranja realmova',
    sectionGeneral: 'Općenito',
    mappingsNoRealms: 'Nijedan vanjski realm nije konfiguriran — površina za mapiranje otključava se čim realm postoji.',
    mappingsNoRealmsLink: 'Otvori karticu Realmovi i SSO',
    mfaRequired: 'Obveza MFA-a',
    mfaRequiredChip: 'Nameće MFA',
    mfaNotRequiredChip: 'Bez obveze',
    mfaRequiredHint:
      'Čisti OR: grupa može svojim članovima DODATI obvezu drugog faktora — i vanjskim identitetima, preko mapiranja realmova — nikad je ukinuti. Vrijedi od sljedeće prijave: otvorene sesije se ne zatvaraju.'
  },
  users: {
    title: 'Korisnici',
    createTitle: 'Stvori korisnika',
    editTitle: 'Uredi korisnika',
    username: 'Korisničko ime',
    usernameHint: 'Mala slova, znamenke, točke i crtice',
    displayName: 'Prikazano ime',
    enabled: 'Omogućen',
    state: 'Stanje',
    enabledChip: 'Omogućen',
    disabledChip: 'Onemogućen',
    lockedChip: 'Zaključan',
    password: 'Lozinka',
    passwordSetChip: 'Postavljena',
    mustChangeChip: 'Treba promijeniti',
    initialPassword: 'Početna lozinka',
    initialPasswordHint: 'Korisnik će je morati promijeniti pri prvoj prijavi',
    lastLogin: 'Posljednja prijava',
    neverLoggedIn: 'Nikad prijavljen',
    setPasswordTitle: 'Postavite lozinku',
    setPasswordHint: 'Administrativna zamjena — zahtijeva vašu lozinku (sudo način) i obvezuje korisnika da je promijeni pri sljedećoj prijavi.',
    operatorPassword: 'Vaša lozinka',
    unlock: 'Otključaj račun',
    revokeTitle: 'Opozovite sesije',
    revokeBody: 'Sve aktivne sesije ovog korisnika odmah se prekidaju.',
    revokeIncludeTokens: 'Opozovi i aplikacijske tokene',
    revokeConfirm: 'Opozovi',
    tabAccount: 'Račun',
    tabSecurity: 'Sigurnost',
    usernameImmutableHint: 'Korisničko ime je identitet računa — fiksirano pri stvaranju',
    groups: 'Grupe',
    noGroups: 'Nema grupa',
    mustChangePassword: 'Obvezna promjena lozinke',
    failedAttempts: 'Neuspjeli pokušaji prijave',
    lockedUntil: 'Zaključan do',
    tabUsers: 'Korisnici',
    tabGroups: 'Grupe',
    tabRealms: 'Realmovi i SSO',
    tabMfa: 'MFA',
    mfa: {
      title: 'Drugi faktor (MFA)',
      methodsTitle: 'Dostupne metode',
      methodsSubtitle: 'Ono što ova instalacija zna provjeriti kao drugi faktor',
      methodsError: 'Registar metoda nije moguće učitati',
      builtinChip: 'Ugrađeno',
      enrollableChip: 'Enrollment u TVirtu',
      delegatedChip: 'Upravljano izvana',
      state: 'Stanje',
      stateActive: 'Aktivan',
      statePending: 'Čeka enrollment',
      stateNone: 'Nije upisan',
      required: 'Obveza MFA-a',
      requiredChip: 'Obavezno',
      notRequiredChip: 'Nije obavezno',
      enrolledAt: 'Datum enrollmenta',
      enrolledMethods: 'Upisane metode',
      noMethods: 'Nema enrollmenta',
      codesRemaining: 'Preostali kodovi za oporavak',
      resetTitle: 'Resetirajte drugi faktor',
      resetHint:
        'Enrollment i svi kodovi za oporavak se brišu: pri sljedećoj prijavi korisnik ponavlja enrollment ispočetka. Obveza MFA-a ostaje kakva jest — administrator nikad ne postavlja tajnu, samo je briše.',
      resetConfirm: 'Resetiraj',
      resetError: 'Drugi faktor nije moguće resetirati',
      empty: 'Još nema upravljanih korisnika — računi se ovdje pojavljuju čim postoje, svaki sa svojim stanjem drugog faktora.',
      viaSelf: 'Osobno',
      viaSelfHint: 'Osobni doprinos računa (njegov flag) — jedini dio koji olovka uređuje.',
      viaGroupHint: 'Obveza naslijeđena od ove grupe: uklanjanje osobnog flaga ne oslobađa korisnika — djeluje se na grupi, na kartici Grupe.',
      subject: 'Identitet',
      lastSeenAt: 'Posljednja potvrda',
      enrollmentPending: 'Na čekanju',
      orphanChip: 'Osirotio',
      orphanDirectoryMiss: 'Identitet više nije u direktoriju',
      orphanRealmRemoved: 'Realm je uklonjen iz TVirta',
      orphanedAt: 'Osirotio od',
      directoryUuid: 'UUID u direktoriju',
      externalTitle: 'Vanjski enrollmenti',
      externalEmpty: 'Još nema vanjskih enrollmenta — nastaje pri prvoj prijavi identiteta direktorija s obvezom MFA-a.',
      orphanHelp:
        'Osirotjeli enrollment nikad se ne briše sam od sebe: to je sigurnosni materijal — ostaje za audit i, ako se identitet ponovno pojavi u direktoriju, pronalazi svoj faktor. Jedini izlaz je administrativni reset.',
      visibilityHint: 'Vanjski enrollmenti nalaze se u korijenu klastera: vidi ih samo tko ima user.read nad cijelim stablom.',
      orphanResetHint:
        'Osirotjeli redak uklanja se zauvijek: nitko ga više ne potražuje. Ako se identitet ikad vrati u direktorij, ponovno će proći enrollment ispočetka.',
      enforcingTitle: 'Grupe koje nameću MFA',
      enforcingSubtitle:
        'Sidro obveze za vanjske identitete je grupa: njezina mapiranja realmova govore do koje populacije direktorija dopire. Vanjski enrollment nastaje pri prvoj prijavi obvezanog korisnika.',
      enforcingEmpty: 'Nijedna grupa ne nameće MFA — obveza se uključuje na grupi, s kartice Grupe.',
      enforcingError: 'Grupe koje nameću MFA nije moguće učitati'
    }
  },
  realms: {
    title: 'Autentifikacijski realmovi',
    createTitle: 'Stvori realm',
    editTitle: 'Uredi realm',
    name: 'Realm',
    nameHint: 'Domena koju korisnici pišu nakon @ (example.com) — nepromjenjiva nakon stvaranja',
    nameImmutableHint: 'Ime realma utisnuto je u svaku sesiju i svaki redak audita koji ga je ikad imenovao — preimenovanje bi prepisalo povijest',
    kind: 'Vrsta',
    kindLdap: 'LDAP / Active Directory',
    kindHint: 'OIDC i SAML stižu sa sljedećim roundovima — danas je realm LDAPv3 direktorij',
    kindCategory: 'Vrsta realma',
    kindSelectHint: 'Odaberite vrstu direktorija na kojem će ovaj realm autentificirati.',
    kindCard: {
      ldap: {
        name: 'LDAP / Active Directory',
        desc: 'Korisničko ime i lozinka provjeravaju se bindom na LDAPv3 direktoriju — Active Directory, FreeIPA, OpenLDAP.'
      },
      oidc: {
        name: 'OpenID Connect',
        desc: 'Single sign-on iz preglednika delegiran OpenID Connect identity provideru — stiže sa sljedećim roundovima.'
      },
      saml: {
        name: 'SAML 2.0',
        desc: 'Poslovni single sign-on putem SAML 2.0 asercija — stiže sa sljedećim roundovima.'
      }
    },
    tabBind: 'Bind',
    enabled: 'Omogućen',
    urls: 'Poslužitelji direktorija',
    urlsHint: 'Jedan ldap:// ili ldaps:// URL po retku (1–8), isprobavaju se redom — failover, nikad balansiranje',
    startTls: 'StartTLS',
    verifyCertificate: 'Provjeri certifikat',
    cleartextWarning: 'Bez ldaps:// ili StartTLS-a lozinka za bind prolazi mrežom u čistom tekstu — prihvatljivo u laboratoriju, nikad u produkciji.',
    noVerifyWarning: 'Neprovjerena TLS sesija ne autentificira nikoga: isključite provjeru samo prema direktoriju koji ne možete popraviti.',
    caCertificate: 'CA certifikat (PEM)',
    caCertificateHint: 'Neobavezni CA bundle fiksiran za TLS/StartTLS handshake ovog realma; prazno ga uklanja',
    caCertificatePinned: 'Fiksiran',
    connectTimeout: 'Timeout (sekunde)',
    connectTimeoutHint: 'Rok spajanja i zahtjeva po URL-u (1–60); po isteku isprobava se sljedeći URL',
    bindDn: 'Bind DN',
    bindDnHint: 'Service account koji izvodi pretragu korisnika; prazno = anonimni search bind (AD ga odbija)',
    anonymousBind: 'Anonimni search bind',
    bindCredential: 'Lozinka za bind (keystore)',
    bindCredentialHint: 'Unos usernamePassword u keystoreu koji čuva lozinku za bind — tajna nikad ne živi na realmu',
    bindCredentialNone: 'Nijedna (anonimni bind)',
    bindCredentialEmpty: 'U keystoreu još nema unosa usernamePassword — stvorite jedan u Sustav > Vjerodajnice za lozinku za bind.',
    baseDn: 'Base DN',
    baseDnHint: 'Podstablo od kojeg počinje pretraga korisnika (DC=example,DC=com)',
    userFilter: 'Korisnički filtar',
    userFilterHint: '%u se zamjenjuje lokalnim dijelom prijave, uz RFC 4515 escape; direktoriji koji nisu AD tipično žele (&(objectClass=inetOrgPerson)(uid=%u))',
    memberOfAttribute: 'Atribut memberOf',
    memberOfAttributeHint: 'Čita se samo jednom, pri prijavi — nemapirane grupe se zanemaruju, ugniježđivanje se ne razrješava',
    uuidAttribute: 'Atribut UUID',
    uuidAttributeHint: 'Nepromjenjivi UUID unutar realma (objectGUID na AD-u, entryUUID na OpenLDAP-u) — utisnut u audit uz korisnik@realm',
    displayNameAttribute: 'Atribut prikazanog imena',
    displayNameAttributeHint: 'Koristi se za pozdrav korisniku; u nedostatku se koristi ime za prijavu',
    sudoHint: 'Upisi na realmove sudo su zaštićeni: realm su ulazna vrata u platformu',
    deleteBody: 'Mapiranja grupa realma odlaze s njim; sesije koje je autentificirao ostaju žive do isteka — izbrisani realm jednostavno više nikoga ne pušta unutra.',
    tabConnection: 'Veza',
    tabDirectory: 'Direktorij',
    testTitle: 'Test veze',
    testHint: 'Konfiguracijska sonda, nikad autentifikacija: povezuje se, radi bind sa service accountom i — uz korisničko ime — izvršava korisnički filtar.',
    testUsername: 'Korisničko ime (neobavezno)',
    testUsernameHint: 'Lokalni dio na kojem se izvršava korisnički filtar — 1 podudaranje je zdrav odgovor',
    testRun: 'Pokreni test',
    testError: 'Sondu nije moguće izvršiti',
    testReachable: 'Direktorij dostupan, servisni bind prihvaćen',
    testUnreachable: 'Direktorij NIJE dostupan',
    matchedOne: 'Korisnički filtar pronašao je točno 1 unos — zdrav odgovor.',
    matchedNone: 'Korisnički filtar nije pronašao nijedan unos: filtar ili base DN je pogrešan.',
    matchedMany: 'Broj unosa koje je korisnički filtar pronašao: {count} — nije selektivan, a prijave bi bile dvosmislene (odbijene).',
    mappingsPointer: 'Čemu odgovara vanjska grupa svojstvo je TVirt grupe (njezina mapiranja realmova): točka istine živi na kartici Grupe.',
    mappingsPointerLink: 'Otvori karticu Grupe',
    rootHomeHint: 'Identiteti vanjskog realma žive u korijenu klastera, nikad u vDC-u: dozvole se dodjeljuju gdje su potrebne, ovlaštenjima — na grupi ili izravno na korisniku, baš kao i za nativne korisnike.'
  },
  credentials: {
    title: 'Vjerodajnice',
    createTitle: 'Stvori vjerodajnicu',
    editTitle: 'Uredi vjerodajnicu',
    kind: 'Vrsta',
    kindUsernamePassword: 'Korisničko ime i lozinka',
    kindIscsiChap: 'CHAP (iSCSI)',
    kindNvmeDhchap: 'DH-HMAC-CHAP (NVMe)',
    kindCephx: 'cephx (Ceph identitet)',
    kindHintUsernamePassword: 'Nepromjenjivo. Za CIFS/SMB storage — mount račun čiju tajnu worker koristi u trenutku mounta.',
    kindHintIscsiChap: 'Nepromjenjivo. Za iSCSI CHAP autentifikaciju — username = CHAP ime, secret = CHAP tajna.',
    kindHintNvmeDhchap: 'Nepromjenjivo. Za DH-HMAC-CHAP za NVMe over Fabrics — secret = blob DHHC-1:xx:…; username je samo oznaka.',
    kindHintCephx: 'Nepromjenjivo. Za Ceph klijente — username = ime klijenta (client.…), secret = base64 ključ.',
    kindImmutableHint: 'Vrsta je nepromjenjiva nakon stvaranja — promjena znači novu vjerodajnicu.',
    username: 'Korisničko ime',
    usernameChap: 'CHAP ime',
    usernameNvme: 'Oznaka',
    usernameCephx: 'Ime klijenta',
    usernameHint: 'Neobavezno ime računa kojem tajna pripada',
    usernameHintChap: 'CHAP ime kojim se initiator autentificira',
    usernameHintNvme: 'Transport je ne koristi — slobodna oznaka za vašu evidenciju',
    usernameHintCephx: 'Ime cephx klijenta — prefiks client. se tolerira',
    secret: 'Tajna',
    secretHint: 'Samo za pisanje: koriste je konzumenti, nikad se više ne prikazuje.',
    secretHintNvmeDhchap: 'Samo za pisanje: host DH-HMAC-CHAP tajna u kanonskom obliku DHHC-1:xx:… — koriste je konzumenti, nikad se više ne prikazuje.',
    secretHintCephx: 'Samo za pisanje: base64 cephx ključ — koriste ga konzumenti, nikad se više ne prikazuje.',
    secretEditHint: 'Ostavite prazno da tajna ostane nepromijenjena — ispunjavanje je rotira.',
    createdAt: 'Stvorena',
    inUseError: "'{name}' je referencirana u konfiguraciji nekog storagea — najprije je ondje odvojite.",
    nameHint: 'Mala slova, znamenke i crtice (DNS-1123); jedinstveno po scopeu',
    rotateTitle: 'Rotirajte tajnu',
    rotateHint: 'Samo za pisanje: nova tajna zamjenjuje pohranjenu — konzumenti je preuzimaju pri sljedećem mountu.',
    tabSecrets: 'Tajne',
    tabCertificates: 'Certifikati',
    tabAuthorities: 'Certifikacijska tijela',
    certificatesTitle: 'Certifikati',
    authoritiesTitle: 'Certifikacijska tijela',
    caCreateTitle: 'Novi CA',
    certCreateTitle: 'Novi certifikat',
    caMode: 'Izvor',
    caModeGenerate: 'Generiraj s TVirtom',
    caModeImport: 'Uvezi (ključ + certifikat)',
    certMode: 'Izvor',
    certModeIssue: 'Izdaj iz CA-a u keystoreu',
    certModeImport: 'Uvezi (ključ + certifikat)',
    issuingCa: 'CA izdavatelj',
    issuingCaHint: 'Certifikat nastaje u scopeu CA-a, uz zabilježen parent',
    noCasHint: 'U keystoreu još nema nijednog CA-a — najprije ga generirajte ili uvezite na kartici CA',
    commonName: 'Common name (CN)',
    commonNameCaHint: 'Subject CA-a: slova, znamenke, razmak, točka, podvlaka, crtica',
    commonNameCertHint: 'OpenVPN identificira klijente po CN-u — držite ga jedinstvenim po CA-u',
    days: 'Valjanost (dani)',
    daysCaHint: '1–7300 dana; 3650 (10 godina) je zadano',
    daysCertHint: '1–3650 dana; 365 je zadano',
    keyType: 'Vrsta ključa',
    keyTypeHint: 'EC P-256 je zadano; RSA za legacy konzumente',
    usage: 'Upotreba',
    usageClient: 'Klijent (clientAuth)',
    usageServer: 'Poslužitelj (serverAuth)',
    usageHint: 'Extended key usage za koji se certifikat izdaje',
    san: 'Alternativna imena (SAN)',
    sanHint: 'Odvojena zarezom; IP literali postaju unosi IP:, ostalo DNS:',
    keyPem: 'Privatni ključ (PEM)',
    keyPemHint: 'Samo za pisanje: čuva se u keystoreu, nikad se više ne prikazuje',
    certPem: 'Certifikat (PEM)',
    certPemHint: 'Javni certifikat koji se sparuje s ključem',
    certPemCaHint: 'CA certifikat koji se sparuje s ključem (basicConstraints CA)',
    subject: 'Subject',
    issuer: 'Izdavatelj',
    parentCa: 'CA izdavatelj',
    parentCaImported: 'Uvezen — izdan izvan TVirta',
    serial: 'Serijski broj',
    fingerprint: 'Fingerprint (SHA-256)',
    validFrom: 'Vrijedi od',
    validUntil: 'Vrijedi do',
    expiry: 'Istek',
    expired: 'Istekao',
    expiresInDays: 'Istječe za {days} d',
    revoked: 'Opozvan',
    revokedAtLabel: 'Opozvan dana',
    revokeTitle: 'Opozovite certifikat',
    revokeAction: 'Opozovi',
    revokeWarning: 'Opoziv je konačan: serijski broj ulazi u CRL CA-a izdavatelja i svaki konzument koji odbija opozvane certifikate (prije svih OpenVPN) odbit će i ovaj. Un-revoke ne postoji.',
    exportPem: 'Izvezi PEM',
    exportChain: 'Izvezi bundle lanca',
    exportCrl: 'Izvezi CRL',
    materialImmutableHint: 'X.509 materijal je nepromjenjiv — ponovno izdajte ili ponovno uvezite',
    caInUseError: "'{name}' još ima žive izdane certifikate (ili ga neki storage referencira) — najprije ih opozovite ili izbrišite."
  },
  proximity: {
    title: 'TVirt Proximity',
    subtitle: 'Smještaj, dostupnost i afinitet — gdje se izvode VM-ovi klastera i trebaju li biti uključeni',
    loadError: 'Panel Proximity zahtijeva store klastera — stanje flote trenutačno nije dostupno',
    config: {
      title: 'Konfiguracija',
      subtitle: 'Politika smještaja na razini klastera',
      save: 'Spremi',
      saveError: 'Konfiguracija je odbijena',
      strategy: 'Strategija odabira',
      strategy_leastUsedResources: 'Najmanje iskorišteni resursi',
      strategy_leastVms: 'Najmanje VM-ova',
      strategy_random: 'Nasumično',
      strategyLeastUsedResourcesHint: 'Među valjanim kandidatima, čvor s najviše preostalog iskoristivog RAM-a (uočeni ukupni − rezervacija hosta − uključeni VM-ovi), vCPU angažman kao razrješenje izjednačenja. Deterministički pri jednakim podacima.',
      strategyLeastVmsHint: 'Među valjanim kandidatima, čvor s najmanje uključenih VM-ova; izjednačenja se razrješavaju po imenu čvora. Deterministički pri jednakim podacima.',
      strategyRandomHint: 'Uniformno nasumično među valjanim kandidatima.',
      liveness: 'Prag živosti čvorova (sekunde)',
      livenessHint: 'Član koji šuti preko ovog praga je nedostupan: isključen iz smještaja i — ako nije na održavanju — HA decider ga smatra mrtvim, ograđuje ga i njegove HA VM-ove ponovno pokreće drugdje.',
      decider: 'HA decider',
      deciderNone: 'još nije izabran'
    },
    nodesTitle: 'Čvorovi',
    nodesSubtitle: 'Živost i empirijski kapacitet — iskoristivi RAM = ukupno − baza − angažirano',
    nodeCol: 'Čvor',
    stateCol: 'Stanje',
    ramCol: 'RAM (ukupno − baza − angažirano)',
    usableCol: 'Iskoristivo',
    vmsCol: 'Opterećenje',
    neverSeen: 'nikad viđen',
    freshChip: 'dostupan',
    staleChip: 'nedostupan',
    attestedChip: 'potvrđeno isključen',
    ramFormula: 'ukupno − baza − angažirano',
    haTitle: 'Visoka dostupnost',
    haSubtitle: 'VM-ovi s HA flagom "uvijek su uključeni": TVirt ih ponovno pokreće nakon svakog zaustavljanja koje nije zatraženo — isti čvor uz backoff, drugi čvor kad njihov umre (samo dijeljeni storage).',
    haNone: 'Nijedan VM još nema HA flag — omogućite ga ovdje ili u detaljima VM-a.',
    haVmCol: 'Virtualni stroj',
    haStateCol: 'Stanje',
    haRestartsCol: 'HA ponovna pokretanja',
    haLastEventCol: 'Posljednji događaj',
    haToggleCol: 'HA',
    haCrashLoop: 'crash loop',
    haToggleError: 'HA promjena je odbijena',
    rules: {
      title: 'Pravila afiniteta',
      createTitle: 'Novo pravilo blizine',
      editTitle: 'Uredi pravilo',
      nameHint: 'Mala slova, znamenke i crtice (DNS oznaka)',
      vms: 'Virtualni strojevi',
      vmsHint: 'Najmanje dva VM-a — pravilo veže gdje se izvode jedni u odnosu na druge',
      type: 'Vrsta',
      affinity: 'Afinitet (zajedno)',
      antiAffinity: 'Anti-afinitet (odvojeno)',
      typeAffinityHint: 'VM-ovi se trebaju izvoditi na ISTOM čvoru.',
      typeAntiAffinityHint: 'VM-ovi se trebaju izvoditi na RAZLIČITIM čvorovima — klasični HA par.',
      mode: 'Način',
      hard: 'hard',
      soft: 'soft',
      modeHardHint: 'Kršenja odbijaju operaciju (pokretanje, migracija, failover) uz rječitu pogrešku.',
      modeSoftHint: 'Preferencija, nikad blokirajuća: smještaj koji krši pravilo nastavlja se uz vidljivo upozorenje.',
      satisfied: 'Smještaj',
      satisfiedYes: 'zadovoljen',
      satisfiedNo: 'prekršen',
      violations: 'Kršenja',
      noViolations: 'Nijedno'
    },
    events: {
      title: 'HA događaji',
      subtitle: 'Dnevnik dostupnosti — ponovna pokretanja, fencing, failoveri i pošteni preskoci',
      none: 'Još ništa.',
      when: 'Kada',
      kind: 'Događaj',
      target: 'Objekt',
      detail: 'Detalj',
      kindRestarted: 'HA ponovno pokretanje',
      kindGaveUp: 'odustajanje (crash loop)',
      kindNodeAttested: 'čvor ograđen',
      kindFailedOver: 'failover',
      kindNoCandidate: 'nema kandidata',
      kindStorageLocalSkip: 'preskočeno (lokalni storage)',
      kindZombieFenced: 'zombie prekinut'
    }
  }
}
